export interface SeriesTheme {
  name: string;
  slug: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  gradientStart: string;
  gradientEnd: string;
  fontHeading: string;
  fontBody: string;
  fontSanskrit: string;
}

export const SERIES_THEMES: Record<string, SeriesTheme> = {
  "patanjali-yoga-sutras-2019": {
    name: "Patanjali Yoga Sutras",
    slug: "patanjali-yoga-sutras-2019",
    primaryColor: "#5F259F",
    secondaryColor: "#FFF8F0",
    accentColor: "#F37021",
    gradientStart: "#1A0A2E",
    gradientEnd: "#2D1B4E",
    fontHeading: "Playfair Display",
    fontBody: "Poppins",
    fontSanskrit: "Noto Sans Devanagari",
  },
  "narada-bhakti-sutras": {
    name: "Narada Bhakti Sutras",
    slug: "narada-bhakti-sutras",
    primaryColor: "#5F259F",
    secondaryColor: "#FFF8F0",
    accentColor: "#D4A843",
    gradientStart: "#0D1B3E",
    gradientEnd: "#1A237E",
    fontHeading: "Playfair Display",
    fontBody: "Poppins",
    fontSanskrit: "Noto Sans Devanagari",
  },
  "ashtavakra-gita": {
    name: "Ashtavakra Gita",
    slug: "ashtavakra-gita",
    primaryColor: "#5F259F",
    secondaryColor: "#FFF8F0",
    accentColor: "#F37021",
    gradientStart: "#1A0A2E",
    gradientEnd: "#3E1B2D",
    fontHeading: "Playfair Display",
    fontBody: "Poppins",
    fontSanskrit: "Noto Sans Devanagari",
  },
};

export const PLATFORMS = {
  youtube: { width: 1920, height: 1080, fps: 30, label: "YouTube" },
  reels: { width: 1080, height: 1920, fps: 30, label: "Instagram Reels" },
  tiktok: { width: 1080, height: 1920, fps: 30, label: "TikTok" },
} as const;

export type Platform = keyof typeof PLATFORMS;

export const LAYOUT = {
  landscape: {
    textArea: { x: 280, y: 180, w: 1360, h: 720 },
    fontSize: { scripture: 52, body: 38, caption: 26, hook: 56 },
    subtitleY: 820,
  },
  portrait: {
    textArea: { x: 80, y: 500, w: 920, h: 920 },
    fontSize: { scripture: 44, body: 34, caption: 22, hook: 48 },
    subtitleY: 1400,
  },
} as const;

export type Format = keyof typeof LAYOUT;

export const SANSKRIT_TERMS = [
  "Narada", "Nārada", "Rishi", "Ṛṣi", "Krishna", "Kṛṣṇa", "Gopi",
  "Bhakti", "Sutra", "Sūtra", "Jnana", "Jñāna", "Yoga", "Samadhi",
  "Samādhi", "Dharma", "Karma", "Satsang", "Guru", "Gurudev",
  "Vedanta", "Vedānta", "Upanishad", "Mantra", "Puja", "Seva",
  "Atman", "Ātman", "Brahman", "Moksha", "Mokṣa", "Pranayama",
  "Prāṇāyāma", "Kundalini", "Kuṇḍalinī", "Chakra", "Patanjali",
  "Patañjali", "Ashtavakra", "Aṣṭāvakra", "Janaka", "Kaivalya",
  "Vibhuti", "Sadhana", "Sādhana", "Pada", "Sudarshan Kriya", "Om",
  "Shiva", "Vishnu", "Gita", "Gītā", "Veda", "Vedas", "Maharishi",
  "Chitta", "Vritti", "Nirodha", "Purusha", "Prakriti", "Dharana",
  "Dhyana", "Pratyahara", "Yama", "Niyama", "Asana",
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
